import Icons from "../../../resources/icons/Icons";
import classes from "./CustomIcon.module.css";

const CustomIcon = (props) => {
  const iconClass = props.addOpacity
    ? `${classes.icon} ${classes.iconOpacity}`
    : props.customIconClass ? props.customIconClass : classes.icon;
  if (props.iconName) {
    const iconPath = Icons[props.iconName]
      ? Icons[props.iconName]
      : Icons.DEFAULT_SITE_ICON;
    return (
      <img
        className={`${iconClass} ${props.className}`}
        src={iconPath}
        alt="custom icon"
      />
    );
  } else {
    return (
      <img
        className={`${iconClass} ${props.className}`}
        src={props.img}
        alt="custom icon"
      />
    );
  }
};

export default CustomIcon;
